(() => {
  const cards = document.querySelectorAll('.hz-halloween-campaign [data-hz-reveal]');
  if (!cards.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    cards.forEach((card) => card.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries, currentObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      currentObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -45px 0px', threshold: 0.08 });
  cards.forEach((card) => observer.observe(card));
})();
